import React, { useEffect, useRef, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getFinanceVoucherEntryLi } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const VoucherEntryLi = ({
  control,
  name,
  onSelectChange,
  dashboardBg,
  placeholder,
  voucherType,
  clearable,
  partyName,
  disabled,
  purchaseVoucherId,
  voucherInvoice,
  salesVoucherId,
  grnVoucher,
  statusApproved,
  supplierId,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [countriesData, setCountriesData] = useState([])

   // Ref to store timeout ID
  const debounceTimeout = useRef(null)

  const loadOptions = async () => {
    const data = await getFinanceVoucherEntryLi({ voucherType, partyName, purchaseVoucherId, voucherInvoice, salesVoucherId, grnVoucher, statusApproved, supplierId })
    setIsLoading(false)
    const response = data?.data?.map(dta => {
      return {
        label: dta?.ref_number && ucfirst(dta.ref_number),
        value: dta.id,
        ...dta,
      }
    })

    setCountriesData(response)
  }

  // useEffect(() => {
  //   loadOptions()
  // }, [voucherType, partyName, purchaseVoucherId, voucherInvoice, salesVoucherId])

    useEffect(() => {
    // Clear any previous debounce timer
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current)
    }

    // Set a new debounce timer
    debounceTimeout.current = setTimeout(() => {
      loadOptions()
    }, 300) // Adjust debounce delay (ms) as needed

    // Cleanup on unmount
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current)
      }
    }
  }, [JSON.stringify(voucherType), partyName, purchaseVoucherId, supplierId, JSON.stringify(voucherInvoice), salesVoucherId, grnVoucher, statusApproved])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={countriesData}
              // placeholder={placeholder ? placeholder : "Select"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              isClearable={clearable ? clearable : false}
              value={value}
              classNamePrefix="react-select"
              className={`elevate-dropdown ${
                dashboardBg ? "elevate-dropdown-new-bg" : ""
              }`}
              menuPortalTarget={document.querySelector("body")}
              isDisabled={disabled ? disabled : false}
            />
          )
        }}
      />
    </div>
  )
}

export default VoucherEntryLi
